import packageJson from '../../package.json'

export const APP_VERSION = packageJson.version
export const APP_VERSION_LABEL = `v${APP_VERSION}`
